// Module
var code = "\n<div class=\"btn-group schema-form-actions {{form.htmlClass}}\" ng-transclude=\"\"></div>";
// Exports
export default code;